<template lang="pug">
div(
  :class="[mask]"
  :style="imageStyle"
).page-image
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PageImage',
  props: {
    src: { type: String, default: '' },
    mask: { type: String, default: '' },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: 10 },
  },
  data() {
    return {}
  },
  computed: {
    vHeight() {
      if (_.isNumber(this.height)) {
        return `${this.height}em`
      }
      return this.height
    },
    vWidth() {
      if (!this.width) {
        return this.vHeight
      }
      if (_.isNumber(this.width)) {
        return `${this.width}em`
      }
      return this.width
    },
    imageStyle() {
      return {
        backgroundImage: `url('${this.src}')`,
        width: this.vWidth,
        height: this.vHeight,
      }
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {},
  },
}
</script>

<style lang="scss" scoped>
.page-image {
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  flex: 0 0 auto;
  &.circle {
    border-radius: 1000px;
    overflow: hidden;
  }
}
</style>
